import { render, staticRenderFns } from "./DocApproval.vue?vue&type=template&id=417fbbc1&scoped=true&"
import script from "./DocApproval.vue?vue&type=script&lang=js&"
export * from "./DocApproval.vue?vue&type=script&lang=js&"
import style0 from "./DocApproval.vue?vue&type=style&index=0&id=417fbbc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417fbbc1",
  null
  
)

export default component.exports